export default __webpack_public_path__ + "static/media/Banner_TR1S_1440x600.6f4afa2a.png";